module.exports = __webpack_public_path__ + "static/media/1011994.84c7d216.png";